module.exports = __webpack_public_path__ + "static/media/V2_12.4d918e3f.png";